import React from  'react';
import './footer.css';
import GitHubIcon from '@material-ui/icons/GitHub';
import TwitterIcon from '@material-ui/icons/Twitter';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
const Footer = () =>{
    return(
        <footer className='footer'>
         <div className='footer__logo'>
         
         </div>
          <div className='footer__info'>
              <p>&copy; 2022 </p>
              <p>Kenneth Bett</p>
          </div>
          <div className='footer__social'>
             <GitHubIcon />
             <TwitterIcon />
             <LinkedInIcon />
          </div>
        </footer>
    );
}

export default React.memo(Footer);